module.exports = __webpack_public_path__ + "img/mobile_map_siracusa.9bfc5db9.svg";